/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable react/jsx-closing-bracket-location */
import React, { Component } from 'react';
import Avatar from '@material-ui/core/Avatar';
import Paper from '@material-ui/core/Paper';
import Fab from '@material-ui/core/Fab';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import CircularProgress from '@material-ui/core/CircularProgress';
import Swal from 'sweetalert2';
import FormHelperText from '@material-ui/core/FormHelperText';
import Autocomplete from '@material-ui/lab/Autocomplete';
import DateFnsUtils from '@date-io/date-fns';
import MobileFooter from '../../../Component/Common/Profile/MobileFooter';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { Trans, withTranslation } from 'react-i18next';

import { formValidator, LogError } from '../../../AppUtil/AppUtil';
import BuxService from '../../../Service/BuxService';
import UserService from '../../../Service/UserService';
import Loader from '../../Common/Loader';
import Session from '../../../Service/Session';
import OtpScreen from './Otp';
import PageHeaderTitle from '../Profile/PageHeaderTitle';
import ExpandIcon from '../Profile/SvgIcon/ExpandIcon';
import InputLabelMobile from '../Profile/InputLabelMobile';

const PATTERN = window.AppConfig.REGULAR_EXPRESSION;

const styles = theme => ({
	paper: {
		padding: theme.spacing(1),
		marginTop: theme.spacing(1),
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center'
	},
	avatar: {
		margin: theme.spacing(1),
		backgroundColor: theme.palette.secondary.main,
		textAlign: 'center'
	},
	form: {
		width: '100%'
	},
	submit: {
		margin: theme.spacing(3, 0, 2)
	},
	blockdiv: {
		textAlign: 'center'
	},
	displayFlex: {
		display: 'flex'
	},
	center: {
		textAlign: 'center'
	}
});

class index extends Component {
	// NOSONAR

	constructor(props) {
		super(props);
		this.inputLabel = React.createRef();
		this.IdType = [
			{ label: 'SSS – Social Security System', value: 'SSS' },
			{
				label: 'GSIS eCard – Government Services and Insurance Corporation',
				value: 'GSIS'
			},
			{
				label: 'TIN',
				value: 'TIN'
			},
			{
				label: 'Driver’s License – Land Transportation Office',
				value: 'DRL'
			},
			{
				label: 'ACR - Alien Certificate of Registration',
				value: 'AICR'
			},
			{
				label: 'NBI',
				value: 'NBI'
			},
			{ label: 'Passport', value: 'PAS' },
			{ label: 'Philhealth ID', value: 'PHID' },
			{ label: 'School ID', value: 'SCH' },
			{ label: 'UMID', value: 'UMID' },
			{ label: 'Voters ID', value: 'VID' },
			{
				label: 'PRC ID - Philippine Regulatory Commission ID',
				value: 'PRC'
			},
			{
				label: 'Digitized Postal ID Philippine Postal Corporation',
				value: 'POS'
			}
		];

		this.state = {
			_isMainLoading: false,
			_maxLength: '4',
			_openScreen: '',
			_isDateTouch: false,
			_statusRetry: false,
			_isDwollaProcessing: false,
			_agreeTermsAndConditions: false,
			_errorTermsAndConditionNotChecked: '',
			otpScreen: false,
			_DwollaSignUpForm: {
				firstName: {
					value: this.props.currentUser.profile.first_name,
					placeholder: 'First Name',
					isValid: false,
					isTouched: false,
					validationRules: {
						isRequired: {
							value: true,
							errorMsg: 'First Name is required'
						}
					},
					error_text: ''
				},
				lastName: {
					value: this.props.currentUser.profile.last_name,
					placeholder: 'Last Name',
					isValid: false,
					isTouched: false,
					validationRules: {
						isRequired: {
							value: true,
							errorMsg: 'Last Name is required'
						}
					},
					error_text: ''
				},
				emailId: {
					value: this.props.currentUser.profile.email,
					placeholder: 'email',
					isValid: true,
					isTouched: false,
					validationRules: {
						isRequired: {
							value: true,
							errorMsg: 'Valid Email Required'
						},
						pattern: {
							value: PATTERN.EMAIL,
							errorMsg: 'Valid Email Required'
						}
					},
					error_text: ''
				},
				idType: {
					value: this.props.currentUser.profile.id_type ? this.props.currentUser.profile.id_type : {},
					placeholder: 'ID type',
					isValid: false,
					isTouched: false,
					validationRules: {
						isRequired: {
							value: true,
							errorMsg: 'ID type is required'
						}
					},
					error_text: ''
				},
				idNumber: {
					value: this.props.currentUser.profile.id_number,
					placeholder: 'ID Number',
					isValid: false,
					isTouched: false,
					validationRules: {
						isRequired: {
							value: true,
							errorMsg: 'ID Number is Required'
						}
					},
					error_text: ''
				},
				city: {
					value: this.props.currentUser.profile.city,
					placeholder: 'city',
					isValid: false,
					isTouched: false,
					validationRules: {
						isRequired: {
							value: true,
							errorMsg: 'required_city'
						}
					},
					error_text: ''
				},
				address: {
					value: this.props.currentUser.profile.address,
					placeholder: 'address',
					isValid: true,
					isTouched: false,
					validationRules: {
						isRequired: {
							value: true,
							errorMsg: 'required_address'
						}
					},
					error_text: ''
				},
				dob: {
					value: this.props.currentUser.profile.dob ? this.props.currentUser.profile.dob : null,
					placeholder: 'Date of Birth (MM/DD/YYYY)',
					isValid: false,
					isTouched: false,
					validationRules: {
						isRequired: {
							value: true,
							errorMsg: 'required_dob'
						}
					},
					error_text: ''
				}
			}
		};
	}

	setLenderState = value => {
		for (let i = 0; i <= this.props.supportedStates.length; i++) {
			if (this.props.supportedStates[i].value === value) {
				return this.props.supportedStates[i];
			}
		}
	};

	handleTermsConditionChange = e => {
		this.setState({
			_errorTermsAndConditionNotChecked: '',
			_agreeTermsAndConditions: e.target.checked
		});
	};

	handleDropdownChange = (_event, value, name) => {
		const infoForm = {
			...this.state._DwollaSignUpForm
		};
		const updatedFormElement = {
			...infoForm[name]
		};
		updatedFormElement.value = value;
		updatedFormElement.isValid = true;
		updatedFormElement.error_text = '';
		infoForm[name] = updatedFormElement;
		this.setState({
			_DwollaSignUpForm: infoForm
		});
	};

	handleStateChange = (_event, value) => {
		const infoForm = {
			...this.state._DwollaSignUpForm
		};
		const updatedFormElement = {
			...infoForm.state
		};
		updatedFormElement.value = value;
		updatedFormElement.isValid = true;
		updatedFormElement.error_text = '';
		infoForm.state = updatedFormElement;
		this.setState({
			_DwollaSignUpForm: infoForm
		});
	};

	handelInputChange = e => {
		const name = e.target.name;
		const value = e.target.value;
		const signUpForm = {
			...this.state._DwollaSignUpForm
		};
		const updatedFormElement = {
			...signUpForm[name]
		};
		updatedFormElement.value = value;
		updatedFormElement.isValid = true;
		updatedFormElement.error_text = '';
		signUpForm[name] = updatedFormElement;
		this.setState({
			_DwollaSignUpForm: signUpForm
		});
	};

	checkIfUserInRetryStatus = () => {
		const currentUser = this.props.currentUser.profile;
		return (
			this.state._statusRetry ||
			(currentUser.account !== null && currentUser.account.verification_status === 'retry')
		);
	};

	onRetryStatus = () => {
		const signUpForm = {
			...this.state._DwollaSignUpForm
		};
		signUpForm.firstName.value = '';
		signUpForm.lastName.value = '';
		signUpForm.address.value = '';
		signUpForm.city.value = '';
		signUpForm.state.value = '';
		signUpForm.postalCode.value = '';
		signUpForm.dob.value = new Date().setFullYear(new Date().getFullYear() - 18);
		signUpForm.ssn.value = '';
		signUpForm.ssn.placeholder = 'ssn_nine_digits';
		signUpForm.ssn.validationRules.pattern.value = PATTERN.SSN_NINE_DIGITS;
		signUpForm.ssn.validationRules.pattern.errorMsg = 'invalid_ssn_nine_digit';
		this.setState({
			_statusRetry: true,
			_DwollaSignUpForm: signUpForm,
			_agreeTermsAndConditions: false,
			_maxLength: '9'
		});
	};

	openDocumentScreen = () => {
		this.setState({
			_openScreen: 'DOCUMENT_VERIFICATION'
		});
	};

	openKbaScreen = () => {
		this.setState({
			_openScreen: 'KBA'
		});
	};

	closeDwollaScreen = () => {
		this.setState({
			_openScreen: ''
		});
		this.setScreenWhenBackToDwolla();
	};

	onSubmitHandler = async e => {
		e.preventDefault();
		if (!this.formValidator()) {
			return false;
		}
		this.setState({ _isMainLoading: true });

		try {
			console.log('here 1');
			const response = await BuxService.getEmailAuthToken();
			console.log(response);
			if (response) {
				console.log('here 2');
				Session.store('EMAIL_AUTH_TOKEN', response.token);
				this.setState({
					otpScreen: true
				});
				this.setState({ _isMainLoading: false });
			} else {
				this.setState({ _isMainLoading: false });
				console.log('here 3');
				this.toastSomethingWentWrong();
			}
		} catch (err) {
			LogError(err);
			console.log('here 4');
			this.setState({ _isMainLoading: false });
			this.toastSomethingWentWrong();
		}
	};

	handleDateChange = date => {
		const signUpForm = {
			...this.state._DwollaSignUpForm
		};
		const updatedFormElement = {
			...signUpForm.dob
		};
		updatedFormElement.value = date;
		updatedFormElement.isValid = true;
		signUpForm.dob = updatedFormElement;
		this.setState({
			_isDateTouch: true,
			_DwollaSignUpForm: signUpForm
		});
	};

	formValidator = () => {
		let flag = true;
		const form = { ...this.state._DwollaSignUpForm };
		

		const [updatedForm, isFormValid] = formValidator(form);
		if (!this.state._isDateTouch) {
			updatedForm.dob.isValid = false;
			updatedForm.dob.error_text = 'required_dob';
			flag = false;
		}
		if (updatedForm.idType.value && Object.keys(updatedForm.idType.value).length < 1) {
			updatedForm.idType.isValid = false;
			flag = false;
		}
		this.setState({ _DwollaSignUpForm: updatedForm });
		return isFormValid && flag;
	};

	toastSomethingWentWrong = () => {
		Swal.fire({
			title: this.props.t('error'),
			text: this.props.t('something_went_wrong'),
			// icon: 'error',
			imageUrl: 'https://cdn-icons-png.flaticon.com/512/5219/5219070.png',
			imageAlt: 'Custom Image',
			confirmButtonText: this.props.t('try_again'),
			customClass: 'otp_message_success'
		});
	};

	dwollaProcessingStart = () => {
		this.setState({
			_isDwollaProcessing: true
		});
	};

	dwollaProcessingStop = () => {
		this.setState({
			_isDwollaProcessing: false
		});
	};

	termsConditionsLabel = () => {
		return (
			<Trans i18nKey="DwollaPlaid:terms_conditions_label">
				I agree that payments through LendAmi will be processed by the Bux wallet payment system.
			</Trans>
		);
	};

	setScreenWhenBackToDwolla = async () => {
		await this.setState({
			_isMainLoading: true
		});
		const currentUser = await UserService.updateCurrentUser();
		if (currentUser.profile) {
			await this.props.setCurrentUser(currentUser);
			await this.setState({
				_isMainLoading: false
			});
		}
		const account = currentUser.profile.account;
		if (!account) {
			return;
		}
		if (!account.verification) {
			return;
		}
		const stepRequired = account.verification.stepRequired;
		if (stepRequired === 'retry') {
			this.onRetryStatus();
		} else if (stepRequired === 'document') {
			this.openDocumentScreen();
		} else if (stepRequired === 'kba' || stepRequired === 'kba_initiated') {
			this.openKbaScreen();
		}
	};

	handleBackFromOtp = async () => {
		this.setState({
			otpScreen: false
		});
	};

	oncloseOtp = async () => {
		const currentUser = await UserService.updateCurrentUser();
		if (currentUser.profile) {
			await this.props.setCurrentUser(currentUser);
		}
		await this.props.onBack();
	};

	render() {
		// NOSONAR
		const { classes } = this.props;
		const { t } = this.props;
		if (this.state._isMainLoading) {
			return <Loader />;
		} else if (this.state.otpScreen === true) {
			return (
				<OtpScreen
					dwollaSignUpForm={this.state._DwollaSignUpForm}
					handleBackFromOtp={this.handleBackFromOtp}
					currentUser={this.props.currentUser}
					oncloseOtp={this.oncloseOtp}
				/>
			);
		} else {
			return (
				<Container component="main" maxWidth className="dwollasignupform">
					<PageHeaderTitle
						title={this.state._statusRetry ? t('dwolla_heading_when_retry') : t('dwolla_main_heading')}
						className="create_bank_account  p-x-16"
						onClick={this.props.onBack}
					/>
					<CssBaseline />
					<Paper className={classes.paper}>
						<Grid container justify="center">
							<Grid item sm={10} xs={12}>
								<Paper className="no-shadow">
									<div className={classes.paper}>
										{/* <Avatar className={classes.avatar}>
											<LockOutlinedIcon />
										</Avatar> */}
										{/* {this.state._statusRetry ? (
											<Typography
												className="text-center"
												component="h1"
												style={{
													fontSize: "25px",
													marginTop: "15px",
												}}
												variant="h5"
											>
												{t("dwolla_heading_when_retry")}
											</Typography>
										) : (
											<Typography
												className="text-center main-top-heading"
												component="h1"
												variant="h5"
											>
												{" "}
												{t("dwolla_main_heading")}
											</Typography>
										)} */}
										<form className={classes.form} noValidate onSubmit={this.onSubmitHandler}>
											<InputLabelMobile label="First Name*" />
											<TextField
												autoComplete="firstName"
												className={classes.displayFlex}
												disabled={!this.state._statusRetry}
												error={
													!this.state._DwollaSignUpForm.firstName.isValid &&
													this.state._DwollaSignUpForm.firstName.isTouched
												}
												fullWidth
												helperText={
													!this.state._DwollaSignUpForm.firstName.isValid &&
													this.state._DwollaSignUpForm.firstName.isTouched
														? t(this.state._DwollaSignUpForm.firstName.error_text)
														: ''
												}
												id="firstName"
												// label={t(
												//   this.state._DwollaSignUpForm.firstName.placeholder
												// )}
												placeholder={t(this.state._DwollaSignUpForm.firstName.placeholder)}
												margin="normal"
												name="firstName"
												onChange={this.handelInputChange}
												value={this.state._DwollaSignUpForm.firstName.value}
												variant="outlined"
											/>
											<InputLabelMobile label="Last Name*" />
											<TextField
												autoComplete="lastName"
												className={classes.displayFlex}
												disabled={!this.state._statusRetry}
												error={
													!this.state._DwollaSignUpForm.lastName.isValid &&
													this.state._DwollaSignUpForm.lastName.isTouched
												}
												fullWidth
												helperText={
													!this.state._DwollaSignUpForm.lastName.isValid &&
													this.state._DwollaSignUpForm.lastName.isTouched
														? t(this.state._DwollaSignUpForm.lastName.error_text)
														: ''
												}
												id="lastName"
												// label={t(
												//   this.state._DwollaSignUpForm.lastName.placeholder
												// )}
												placeholder={t(this.state._DwollaSignUpForm.lastName.placeholder)}
												margin="normal"
												name="lastName"
												onChange={this.handelInputChange}
												value={this.state._DwollaSignUpForm.lastName.value}
												variant="outlined"
											/>
											<InputLabelMobile label="Email*" />
											<TextField
												autoComplete="emailId"
												name="emailId"
												className={classes.displayFlex}
												disabled={this.props.currentUser.profile.email ? true : false}
												fullWidth
												// label={t(
												//   this.state._DwollaSignUpForm.emailId.placeholder
												// )}
												placeholder={t(this.state._DwollaSignUpForm.emailId.placeholder)}
												margin="normal"
												value={this.state._DwollaSignUpForm.emailId.value}
												onChange={this.handelInputChange}
												variant="outlined"
												error={
													!this.state._DwollaSignUpForm.emailId.isValid &&
													this.state._DwollaSignUpForm.emailId.isTouched
												}
												helperText={
													!this.state._DwollaSignUpForm.emailId.isValid &&
													this.state._DwollaSignUpForm.emailId.isTouched
														? t(this.state._DwollaSignUpForm.emailId.error_text)
														: ''
												}
											/>
											<InputLabelMobile label="ID Type*" />
											<Autocomplete
												fullwidth
												getOptionLabel={option => option.label || ''}
												id="idType"
												name="idType"
												popupIcon={<ExpandIcon />}
												onChange={(event, value) =>
													this.handleDropdownChange(event, value, 'idType')
												}
												options={this.IdType}
												renderInput={params => (
													<TextField
														{...params}
														// label={t(
														//   this.state._DwollaSignUpForm.idType.placeholder
														// )}
														placeholder={t(this.state._DwollaSignUpForm.idType.placeholder)}
														name="region"
														variant="outlined"
														error={
															!this.state._DwollaSignUpForm.idType.isValid &&
															this.state._DwollaSignUpForm.idType.isTouched
														}
													/>
												)}
												value={this.state._DwollaSignUpForm.idType.value}
											/>
											{!this.state._DwollaSignUpForm.idType.isValid &&
											this.state._DwollaSignUpForm.idType.isTouched ? (
												<FormHelperText
													id="text-red"
													style={{
														margin: '-10px 15px 10px'
													}}>
													{t(this.state._DwollaSignUpForm.idType.error_text)}
												</FormHelperText>
											) : (
												''
											)}
											<InputLabelMobile label="ID Number*" />
											<TextField
												autoComplete="idNumber"
												className={classes.displayFlex}
												error={
													!this.state._DwollaSignUpForm.idNumber.isValid &&
													this.state._DwollaSignUpForm.idNumber.isTouched
												}
												fullWidth
												helperText={
													!this.state._DwollaSignUpForm.idNumber.isValid &&
													this.state._DwollaSignUpForm.idNumber.isTouched
														? t(this.state._DwollaSignUpForm.idNumber.error_text)
														: ''
												}
												id="idNumber"
												// label={t(
												//   this.state._DwollaSignUpForm.idNumber.placeholder
												// )}
												placeholder={t(this.state._DwollaSignUpForm.idNumber.placeholder)}
												name="idNumber"
												onChange={this.handelInputChange}
												required
												value={this.state._DwollaSignUpForm.idNumber.value}
												variant="outlined"
											/>
											<InputLabelMobile label="Birth Date*" />
											<form
												className="text-center"
												onSubmit={e => {
													e.preventDefault();
												}}>
												<MuiPickersUtilsProvider utils={DateFnsUtils}>
													<KeyboardDatePicker
														autoOk
														error={
															!this.state._DwollaSignUpForm.dob.isValid &&
															this.state._DwollaSignUpForm.dob.isTouched
														}
														format="MM/dd/yyyy"
														fullWidth
														id={this.state.disabled ? 'date-picker-dialog' : null}
														KeyboardButtonProps={{
															'aria-label': 'change date'
														}}
														// label={t(
														//   this.state._DwollaSignUpForm.dob.placeholder
														// )}
														placeholder={t(this.state._DwollaSignUpForm.dob.placeholder)}
														maxDate={new Date().setFullYear(new Date().getFullYear() - 18)}
														maxDateMessage={t('max_date_error')}
														name="dob"
														onChange={this.handleDateChange}
														onFocus={this.onFocus}
														value={this.state._DwollaSignUpForm.dob.value}
														inputVariant="outlined"
													/>
													{!this.state._DwollaSignUpForm.dob.isValid &&
													this.state._DwollaSignUpForm.dob.isTouched ? (
														<FormHelperText
															id="text-red"
															style={{
																margin: '-10px 15px 10px'
															}}>
															{t(this.state._DwollaSignUpForm.dob.error_text)}
														</FormHelperText>
													) : (
														''
													)}
												</MuiPickersUtilsProvider>
											</form>
											<InputLabelMobile label="Address*" />
											<TextField
												autoComplete="address"
												className={classes.displayFlex}
												error={
													!this.state._DwollaSignUpForm.address.isValid &&
													this.state._DwollaSignUpForm.address.isTouched
												}
												fullWidth
												helperText={
													!this.state._DwollaSignUpForm.address.isValid &&
													this.state._DwollaSignUpForm.address.isTouched
														? t(this.state._DwollaSignUpForm.address.error_text)
														: ''
												}
												id="address"
												inputProps={{ maxLength: 50 }}
												// label={t(
												//   this.state._DwollaSignUpForm.address.placeholder
												// )}
												placeholder={t(this.state._DwollaSignUpForm.address.placeholder)}
												multiline
												name="address"
												onChange={this.handelInputChange}
												required
												rows="4"
												value={this.state._DwollaSignUpForm.address.value}
												variant="outlined"
											/>
											<InputLabelMobile label="City*" />
											<TextField
												autoComplete="city"
												className={classes.displayFlex}
												error={
													!this.state._DwollaSignUpForm.city.isValid &&
													this.state._DwollaSignUpForm.city.isTouched
												}
												fullWidth
												helperText={
													!this.state._DwollaSignUpForm.city.isValid &&
													this.state._DwollaSignUpForm.city.isTouched
														? t(this.state._DwollaSignUpForm.city.error_text)
														: ''
												}
												id="city"
												// label={t(this.state._DwollaSignUpForm.city.placeholder)}
												placeholder={t(this.state._DwollaSignUpForm.city.placeholder)}
												name="city"
												onChange={this.handelInputChange}
												required
												value={this.state._DwollaSignUpForm.city.value}
												variant="outlined"
											/>
											<div className={classes.blockdiv}>
												<FormControlLabel
													className="text-left"
													control={
														<Checkbox
															checked={this.state._agreeTermsAndConditions}
															color="primary"
															name="TermsAndCondition"
															onChange={this.handleTermsConditionChange}
														/>
													}
													id="checkbox-top"
													label={this.termsConditionsLabel()}
												/>
												<FormHelperText id="text-red">
													{t(this.state._errorTermsAndConditionNotChecked)}
												</FormHelperText>
											</div>
											{/* <div className={classes.blockdiv}>
                        <Fab
                          aria-label="add"
                          className={classes.submit}
                          color="primary"
                          onClick={this.props.onBack}
                          size="medium"
                          style={{
                            marginRight: "10px",
                          }}
                          type="submit"
                          variant="extended"
                        >
                          {t("back_button")} &nbsp;
                        </Fab>
                        <Fab
                          aria-label="add"
                          className={classes.submit}
                          color="primary"
                          disabled={
                            this.state._isDwollaProcessing ||
                            !this.state._agreeTermsAndConditions
                          }
                          onClick={this.onSubmitHandler}
                          size="medium"
                          style={{
                            marginRight: "10px",
                          }}
                          type="submit"
                          variant="extended"
                        >
                          {t("agree_and_continue_button")} &nbsp;
                          {this.state._isDwollaProcessing ? (
                            <CircularProgress disableShrink size={18} />
                          ) : (
                            <ArrowForwardIcon />
                          )}
                        </Fab>
                      </div> */}
											<MobileFooter
												loading={this.state._isDwollaProcessing}
												hasNext={true}
												onClick={this.props.onBack}
												onSubmit={this.onSubmitHandler}
												disabled={
													this.state._isDwollaProcessing ||
													!this.state._agreeTermsAndConditions
												}
											/>
										</form>
									</div>
								</Paper>
							</Grid>
						</Grid>
					</Paper>
				</Container>
			);
		}
	}
}

export default withStyles(styles)(withTranslation(['DwollaPlaid'])(index));
